import { render, staticRenderFns } from "./detail-reimbursement.vue?vue&type=template&id=38dd7dfb"
import script from "./detail-reimbursement.vue?vue&type=script&lang=ts"
export * from "./detail-reimbursement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports